function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  width: 32,
  height: 32,
  rx: 16,
  fill: "#f5f5f7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_60985",
  d: "M18.1,28.514a1.266,1.266,0,0,0,.947-.388l3.761-3.761,3.761,3.761a1.32,1.32,0,0,0,2.254-.919,1.28,1.28,0,0,0-.388-.919L24.66,22.513l3.775-3.789a1.224,1.224,0,0,0,.4-.9,1.293,1.293,0,0,0-1.306-1.306,1.247,1.247,0,0,0-.933.388l-3.789,3.775L19.018,16.92a1.2,1.2,0,0,0-.919-.388,1.281,1.281,0,0,0-1.306,1.292,1.239,1.239,0,0,0,.4.919l3.761,3.775L17.2,26.3a1.208,1.208,0,0,0-.4.9,1.293,1.293,0,0,0,1.3,1.314Z",
  transform: "translate(-6.814 -6.514)",
  fill: "#00001f",
  opacity: 0.34
});

function SvgCloseDialog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_dialog",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialog);
export default __webpack_public_path__ + "static/media/close_dialog.40acfb2b.svg";
export { ForwardRef as ReactComponent };